import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Selector from '../../components/forms/Selector';
import IconSave from '../../components/icons/IconSave';
import language from '../../variables/language';
import '../../css/modals.css';

const BOOL_FIELDS = ['isPaid', 'attendence', 'toPay'];

const emptyValues = () => ({isPaid: '', attendence: '', toPay: '', notes: ''});

export default function EventEditModal({ isOpen, eventId, onClose, onSaved }) {
   const navigate = useNavigate();
   const [values, setValues] = useState(emptyValues());
   const [loading, setLoading] = useState(false);
   const [saving, setSaving] = useState(false);

   useEffect(() => {
      if(!isOpen || !eventId) {
         return;
      }
      setLoading(true);
      axios.get('/api/events/' + eventId, { withCredentials: true })
         .then(response => {
            const data = response.data || {};
            setValues({
               isPaid: data.isPaid === 1 ? '1' : (data.isPaid === 2 ? '2' : ''),
               attendence: data.attendence === 1 ? '1' : (data.attendence === 2 ? '2' : ''),
               toPay: data.toPay === 1 ? '1' : (data.toPay === 2 ? '2' : ''),
               notes: (data.notes && data.notes !== 'null' && data.notes !== 'undefined') ? data.notes : '',
            });
         })
         .catch(err => { if(err.response && err.response.status === 401) navigate('/login'); })
         .finally(() => setLoading(false));
   }, [isOpen, eventId, navigate]);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleFieldChange = (name, value) => {
      setValues(prev => ({...prev, [name]: value}));
   }

   const handleClose = () => {
      setValues(emptyValues());
      onClose();
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving) return;
      setSaving(true);
      const payload = {};
      BOOL_FIELDS.forEach(key => {
         if(values[key] !== '') payload[key] = values[key];
      });
      if(values.notes !== '') payload.notes = values.notes;
      axios.put('/api/events/' + eventId, JSON.stringify(payload), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      }).then(() => {
         setValues(emptyValues());
         onSaved();
      }).catch(err => {
         if(err.response && err.response.status === 401){
            navigate('/login');
         }
         console.log(err);
      }).finally(() => {
         setSaving(false);
      });
   }

   const lang = language[language.lang];

   return (
      <div className="modal-update" onClick={handleClose} style={{ display: 'flex' }}>
         <div className="modal-window event-edit-window" onClick={stopProp}>
            <h3 className="modal-w-title">{lang.modals.events.updateTitle}</h3>
            {loading ? (
               <div className='event-edit-loading'>{lang['Loading ...']}</div>
            ) : (
               <form onSubmit={handleSubmit}>
                  <div className='event-edit-fields'>
                     <div className='flex-from-input-wraper event-edit-field' data-label={lang.isPaid}>
                        <Selector className='submit-field form-selection txt-c'
                           name='isPaid' url='/api/booleans' value={values.isPaid} disabled={false}
                           selectorsHundler={(value) => handleFieldChange('isPaid', value)} />
                     </div>
                     <div className='flex-from-input-wraper event-edit-field' data-label={lang.attendence}>
                        <Selector className='submit-field form-selection txt-c'
                           name='attendence' url='/api/booleans' value={values.attendence} disabled={false}
                           selectorsHundler={(value) => handleFieldChange('attendence', value)} />
                     </div>
                     <div className='flex-from-input-wraper event-edit-field' data-label={lang.toPay}>
                        <Selector className='submit-field form-selection txt-c'
                           name='toPay' url='/api/booleans' value={values.toPay} disabled={false}
                           selectorsHundler={(value) => handleFieldChange('toPay', value)} />
                     </div>
                     <div className='flex-from-input-wraper event-edit-field-full' data-label={lang.notes}>
                        <textarea className='submit-field from-input txt-c event-edit-textarea'
                           placeholder={lang.notes}
                           value={values.notes}
                           onChange={(e) => handleFieldChange('notes', e.target.value)} />
                     </div>
                  </div>
                  <button type='submit' className='event-edit-save-btn' disabled={saving} onClick={handleSubmit}>
                     <IconSave />
                     {saving ? lang['Loading ...'] : lang.save}
                  </button>
               </form>
            )}
         </div>
      </div>
   );
}
